import { render, staticRenderFns } from "./ListSoftware.vue?vue&type=template&id=4cceb615&scoped=true"
import script from "./ListSoftware.vue?vue&type=script&lang=js"
export * from "./ListSoftware.vue?vue&type=script&lang=js"
import style0 from "./ListSoftware.vue?vue&type=style&index=0&id=4cceb615&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cceb615",
  null
  
)

export default component.exports